module.exports = __webpack_public_path__ + "static/8-kristin-c448deeea8e2815a78b1ef5a87f26014.jpg";